import * as defineType from './defineTypeTypes'
import useDefineType from './useDefineType'
import Autocomplete from '../../../../control/autocomplete/autocomplete'
import RichTextEditor from '../../../../control/richTextEditor/richTextEditor'
import MyTextfield from '../../../../control/textfield/textfield'
import Checkbox from '../../../../control/checkbox/checkbox'
import React from 'react'
import { Grid, IconButton, SvgIcon } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import useTranslate from '../../../../i18n/useTranslate'
import MyAccordion from '../../../../control/accordion/accordion'
import ModeAccordion from '../modeAccordion/ModeAccordion'
import { ReactComponent as DocumentIcon } from '../../../../images/document.svg'
import { richEditorRequired } from '../../../../utilities/validate'

//View
const DefineTypeView = (props: defineType.DefineTypeViewType) => {
    const {
        projectType,
        projectData,
        disabled = false,
        isNotAboutPeople = false,
        isShowFieldNotAboutPeople = false,
        onChangProjectType,
        onChangeIsNotAboutPeople,
        useAccordionMode,
        handleSubmitOfficerEdit,
        navigateToLogs,
        displayHistory,
    } = props
    const translate = useTranslate()

    const renderChild = (disabledVal = false) => {
        return (
            <Grid container item justify="flex-start" spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                    {isShowFieldNotAboutPeople && (
                        <Checkbox
                            name="isNotAboutPeople"
                            label={translate.get('LABEL.NOT_ABOUT_PEOPLE')}
                            disabled={disabledVal}
                            onChangeValue={onChangeIsNotAboutPeople}
                        />
                    )}
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <Autocomplete
                        name="projectType"
                        materialInputProps={{
                            label: translate.get('LABEL.PROJECT_TYPE'),
                            placeholder: translate.get('LABEL.PLEASE_SELECT'),
                            disabled: disabledVal || isNotAboutPeople,
                        }}
                        options={projectType}
                        onChangeValue={onChangProjectType}
                        required={!isNotAboutPeople}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <RichTextEditor
                            name={`commentWithFormat`}
                            disabled={disabledVal || isNotAboutPeople}
                            initialRichTextEditor={projectData?.reviewerRemarkWithFormat}
                            label={translate.get('LABEL.REASON_SUGGESTION_NOTICE')}
                            placeholder={''}
                            required={true}
                            validates={[richEditorRequired(`${translate.get('MESSAGE.M013')}`)]}
                            isHideToolbar={disabledVal || isNotAboutPeople}
                            topicID={0}
                        />
                    {/* <MyTextfield
                        name="comment"
                        materialInputProps={{
                            disabled: disabledVal || isNotAboutPeople,
                            label: translate.get('LABEL.REASON_SUGGESTION_NOTICE'),
                            placeholder: translate.get('LABEL.FILL_REASON_SUGGESTION_NOTICE'),
                            size: 'small',
                            rows: 5,
                            multiline: true,
                        }}
                        maxLength={1000}
                    /> */}
                </Grid>
            </Grid>
        )
    }

    const renderHistoryIcon = () => {
        return (
            <IconButton size="small" onClick={navigateToLogs}>
                <SvgIcon fontSize="small" component={DocumentIcon} />
            </IconButton>
        )
    }

    return (
        <React.Fragment>
            {useAccordionMode ? (
                <ModeAccordion
                    title={translate.get('LABEL.DEFINE_PROJECT_TYPE')}
                    renderEditComponent={() => renderChild(false)}
                    renderViewComponent={() => renderChild(true)}
                    fieldNames={['isNotAboutPeople', 'projectType', 'comment']}
                    onConfirm={() => handleSubmitOfficerEdit(['isNotAboutPeople', 'projectType', 'comment'])}
                    isViewMode={true}
                    additionIcon={displayHistory ? renderHistoryIcon : undefined}
                ></ModeAccordion>
            ) : (
                <MyAccordion
                    titleIcon={displayHistory ? renderHistoryIcon : undefined}
                    title={translate.get('LABEL.DEFINE_PROJECT_TYPE')}
                >
                    {renderChild(disabled)}
                </MyAccordion>
            )}
        </React.Fragment>
    )
}

//Controller
const DefineType = (props: defineType.DefineTypeType) => {
    const defineTypeModel = useDefineType(props)
    return <DefineTypeView {...defineTypeModel} {...props} />
}

export default DefineType

const useStyles = makeStyles((theme) => ({}))
